import React, { useState } from 'react'
import { Link } from 'gatsby'
import { Facebook, Instagram, Twitter, Youtube } from 'lucide-react'
import { useFetch } from '../../hooks/use-fetch';
import { LOCAL_DATA } from '../../config/site-content';
import { contentUrl } from '../../utils/db';
import { useMotionValueEvent, useScroll, motion } from 'framer-motion';
import { IContact } from '../types';



const Navbar = () => {
   const { isLoading, error, data } = useFetch(contentUrl)
   const menus = (data?.length > 0 ? data : LOCAL_DATA.siteMenu) as string[];
   const colors = data?.siteColor ? data.siteColor : LOCAL_DATA.colores;
   const contact = (data?.contact.length > 0 ? data.contact : LOCAL_DATA.contact) as IContact;
   const routes = ['', 'sobre', 'portfolio', 'eventos', 'blogs', 'membros', 'servicos', 'testimonial', 'contacto'];
   const menuItems = menus.map((item, index) => ({
      id: index + 1,
      name: item,
      route: routes[index], // Creates a route like "/item-name"
   }));
   const mediaIcon = [
      { url: contact.facebook, icon: <Facebook className='w-4 h-4 hover:text-black' /> },
      { url: contact.twitter, icon: <Twitter className='w-4 h-4 hover:text-black' /> },
      { url: contact.instagram, icon: <Instagram className='w-4 h-4 hover:text-black' /> },
      { url: contact.youtube, icon: <Youtube className='w-4 h-4 hover:text-black' /> },
   ]
   const logo = LOCAL_DATA.logotype

   const { scrollY } = useScroll()

   const [hidden, setHidden] = useState(false)
   useMotionValueEvent(scrollY, 'change', (latest) => {
      const previous = scrollY.getPrevious()
      if (latest > previous && latest > 150) {
         setHidden(true)
      } else {
         setHidden(false)
      }
   })

   return (
      <motion.header
         variants={{
            visible: { y: 0 },
            hidden: { y: '-200%' }
         }}
         animate={hidden ? 'hidden' : 'visible'}
         className={`fixed w-full z-10 h-[92px] pb-3 rounded-md ${hidden ? 'bg-transparent' : 'bg-black md:bg-[#00000085]'}`}>
         <div className='flex items-center justify-between container'>
            <div className='flex items-center gap-4'>
               {mediaIcon.map((item, index) => (
                  <a href={item.url} target="_blank" rel="noopener noreferrer" key={index} className='text-white p-2 rounded-full border-2 border-slate-300 hover:bg-white transition-colors'>
                     {item.icon}
                  </a>
               ))}
            </div>
            <div>
               <div className='flex items-center gap-4'>
                  <p className='text-white text-sm font-semibold'>{contact.phone.join(', ')}</p>
                  <p className='text-white text-sm font-semibold'>{contact.email}</p>
               </div>
            </div>
         </div>
         <nav className='container py-2 flex items-center justify-between navbar'>
            <div className='w-16'>
               <Link to='/'>
                  <img src={logo} width={400} height={400} alt="logo" />
               </Link>
            </div>
            <div className='nav-menu'>
               <ul className='list-none flex items-center justify-center gap-8'>
                  {menuItems.map((item, index) => (
                     <li key={index + 1} className='relative group'>
                        <Link to={`/${item.route}`} className='text-white'>{item.name}</Link>
                     </li>
                  ))}
               </ul>
            </div>
            <Link to='/contacto' className=' p-2 rounded-md text-white  transition-colors hidden lg:block' style={{ background: colors.primary || '' }}>Solicitar serviço</Link>
         </nav>
      </motion.header>
   )
}

export default Navbar;
